import { SETTINGS } from "@Config";
import { HttpService } from "@Shared/http/http.service";
import { Logger, LoggerService } from "@Shared/logger";
import { UIHtmlInterface } from "./_models";
import { APP_EVENTS, STORAGE } from "@Core";
import { UIUtil } from "@Shared/utils";
import { ScreenManager, UI_CONST } from ".";
import { OptionsModule } from "@Modules/options_module";
import { UserProfileNavbarComponent } from "./components";
import { Bus } from "@Modules/event_module";
import { AuthModule } from "@Modules/auth_module";



export class UIModuleClass {
  private Logger: Logger = LoggerService.createLogger("UIModule");
  private htmlData: UIHtmlInterface;
  get HTML(): UIHtmlInterface {
    return this.htmlData;
  }  

  get ScreenManager(): ScreenManager {
    return ScreenManager.Instance;
  }
  
  
  constructor() {
    this.Logger.trace("****  CTOR ****");

  }

  public async init(): Promise<void> {
    this.Logger.trace("UI Module Initializing");
    try {

      await this.getHtmlFromServer();
      this.registerAuthButtonClicks();
      this.handleUserProfileComponent();
      this.handleAdditionalScreenClickListeners();
      return Promise.resolve();
    } catch (error) {      
      throw error;

    }

  }

  private async getHtmlFromServer(): Promise<void> {
    this.Logger.trace("Getting HTML from server...");
    const httpService = new HttpService(`${SETTINGS.awsBaseUrl}data/`, SETTINGS.uiCacheTime);
    Bus.emit(APP_EVENTS.onScriptLoadStart, { scriptName: "HTML" });
    return await httpService.get<UIHtmlInterface>('html.json', STORAGE.htmlCacheKey).then((data) => {
      
      this.htmlData = data;
      this.Logger.trace("Done Retrieving HTML");
      

      return Promise.resolve();
    }).catch((error) => {      
      return Promise.reject(error)
    }).finally(() => {
      Bus.emit(APP_EVENTS.onScriptLoadEnd, { scriptName: "HTML" });
  });
    
  }

  private registerAuthButtonClicks(): void {
    UIUtil.registerDynamicClickEvent<HTMLButtonElement>(UI_CONST.authActionLogin, (event, element) => {
      this.Logger.trace('Login Button clicked:', element.textContent);
      ScreenManager.Instance.showScreen('login');

    });

    UIUtil.registerDynamicClickEvent<HTMLButtonElement>(UI_CONST.authActionLogout, (event, element) => {
      this.Logger.trace('Logout Button clicked:', element.textContent);
      AuthModule.logout();

    });

    UIUtil.registerDynamicClickEvent<HTMLButtonElement>(UI_CONST.authActionRegister, (event, element) => {
      this.Logger.trace('Register Button clicked:', element.textContent);
      ScreenManager.Instance.showScreen('register');

    });

    UIUtil.registerDynamicClickEvent<HTMLButtonElement>(UI_CONST.authActionLoginPS, (event, element) => {
      this.Logger.trace('PS Login Button clicked:', element.textContent);
      ScreenManager.Instance.showScreen('login');

    });

    UIUtil.registerDynamicClickEvent<HTMLButtonElement>(UI_CONST.authActionLogoutPS, (event, element) => {
      this.Logger.trace('PS Logout Button clicked:', element.textContent);
      AuthModule.logout();

    });

    UIUtil.registerDynamicClickEvent<HTMLButtonElement>(UI_CONST.authActionLoginCxt, (event, element) => {
      this.Logger.trace('Cnxt Login Button clicked:', element.textContent);
      ScreenManager.Instance.showScreen('login');

    });

    UIUtil.registerDynamicClickEvent<HTMLButtonElement>(UI_CONST.authActionLogoutCxt, (event, element) => {
      this.Logger.trace('Cnxt Logout Button clicked:', element.textContent);
      AuthModule.logout();

    });
    
  }

  private handleUserProfileComponent(): void {
    const uiOptions = OptionsModule.Options.ui;
    if(uiOptions.userProfile.inject){
      UserProfileNavbarComponent.Instance.setup(uiOptions);
    }
    
  }

  private handleAdditionalScreenClickListeners(): void {
    const uiOptions = OptionsModule.Options.ui;
    if(uiOptions.listeners && uiOptions.listeners.length > 0) {
      this.Logger.trace("Setting up additional screen click listeners...");

      uiOptions.listeners.forEach(listener => {
        if(!listener.enabled) {
          return;
        }
        this.Logger.trace(`Registering screen click listener for: ${listener.screen} with selector: ${listener.selector}`);
        UIUtil.registerDynamicClickEvent<HTMLButtonElement>(listener.selector, (event, element) => {
          event.preventDefault();
          this.Logger.trace(`${listener.screen} Button clicked:`, element.textContent);
          ScreenManager.Instance.showScreen(listener.screen);
        });
      });
    }else {
      this.Logger.trace("No additional screen click listeners to setup.");
    }
    
  }




}
export const UIModule = new UIModuleClass();